import { SettingsState } from "../types";
const env = process.env.NODE_ENV;
const version = require("../../../../package.json").version;

const state: SettingsState = {
  version: version.concat(`-${env}`),
  webhooks: [],
};

export default state;
